import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import { GET_PRODUCTION_DECLARATION_KEY } from '@/keys';
import type { ProductionDeclaration } from '@/types/core/purchase-order/production-declaration';

import { getProductionDeclaration } from './get-production-declaration';

export function useGetProductionDeclaration(
  productionDeclarationId: string,
  token: string | undefined,
): UseSuspenseQueryResult<ProductionDeclaration, Error> {
  return useSuspenseQuery({
    queryKey: [
      ...GET_PRODUCTION_DECLARATION_KEY,
      productionDeclarationId,
      token ?? '',
    ],
    queryFn: async () =>
      await getProductionDeclaration(productionDeclarationId, { token }),
  });
}
